<template>
    <div>
        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap">
                    <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ $t('settings') }}</h1>
                        <ul class="breadcrumb">
                            <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                            <li><router-link to="/settings">{{ $t('menu_settings') }}</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <button class="backBtn" @click="this.$parent.goBack">
                        <span>{{ $t('back') }}</span>
                        <svg class="i_back"><use xlink:href="#i_longArr"></use></svg>
                    </button>
                </div>
            </div>
            <ul class="nav nav-tabs tabsWrap">
                <li v-if="resellerTabs" v-bind:class="resellerTabs ? 'active' : ''" ref="application">
                    <a data-toggle="tab" href="#app_settings_tab">
                        <span>{{ $t('app_settings') }}</span>
                    </a>
                </li>
                <li v-if="resellerTabs">
                    <a data-toggle="tab" href="#halls_tab" ref="halls">
                        <span>{{ $t('halls') }}</span>
                    </a>
                </li>
                <li v-if="resellerTabs">
                    <a data-toggle="tab" href="#tableTypes_tab" ref="tables">
                        <span>{{ $t('tableTypes') }}</span>
                    </a>
                </li>
                <li v-if="resellerTabs">
                    <a data-toggle="tab" href="#equipment_tab" ref="equipment">
                        <span>{{ $t('equipment') }}</span>
                    </a>
                </li>
                <li v-if="adminTabs" v-bind:class="adminTabs ? 'active' :''" ref="banners">
                    <a data-toggle="tab" href="#banners_tab">
                        <span>{{ $t('banners') }}</span>
                    </a>
                </li>
                <li v-if="resellerTabs">
                    <a data-toggle="tab" href="#presets_tab" ref="presets">
                        <span>{{ $t('presets') }}</span>
                    </a>
                </li>
            </ul>
            <div class="innerBox">
                <div class="tab-content">
                    <div v-if="resellerTabs" id="app_settings_tab" v-bind:class="resellerTabs ? 'tab-pane fade in active' :''">
                        <AppSettingsTab></AppSettingsTab>
                    </div>
                    <div v-if="resellerTabs" id="halls_tab" class="tab-pane fade">
                        <HallsTab></HallsTab>
                    </div>
                    <div v-if="resellerTabs" id="tableTypes_tab" class="tab-pane fade">
                        <TableTypesTab></TableTypesTab>
                    </div>
                    <div v-if="resellerTabs" id="equipment_tab" class="tab-pane fade">
                        <EquipmentTab></EquipmentTab>
                    </div>
                    <div v-if="adminTabs" id="banners_tab" v-bind:class="adminTabs ? 'tab-pane fade in active' :''">
                        <BannersTab></BannersTab>
                    </div>
                    <div v-if="resellerTabs" id="presets_tab" class="tab-pane fade">
                        <PresetsTab></PresetsTab>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BannersTab from './Tabs/BannersTab.vue'
    import HallsTab from './Tabs/HallsTab.vue'
    import TableTypesTab from './Tabs/TableTypesTab.vue'
    import EquipmentTab from './Tabs/EquipmentTab.vue'
    import AppSettingsTab from './Tabs/AppSettingsTab.vue'
    import PresetsTab from './Tabs/PresetsTab.vue'

    export default {
        name: 'Settings',
        data() {
            return{
                resellerTabs:false,
                adminTabs:false,
                selectedTab:'',
            }
        },
        components: {
            BannersTab,
            HallsTab,
            TableTypesTab,
            EquipmentTab,
            AppSettingsTab,
            PresetsTab
        },
        beforeMount(){

            this.$data.selectedTab = (typeof this.$router.currentRoute.params.tab !=='undefined' ? this.$router.currentRoute.params.tab : '');

            if(this.$store.state.user.type == 1){
                this.$data.adminTabs = true;
            }else if(this.$store.state.user.type == 2){
                this.$data.resellerTabs = true;
            }else{
                this.$router.push('../');
            }
        },

        mounted(){
            if(this.$data.selectedTab != ''){
                let elm = this.$refs[this.$data.selectedTab];
                if(typeof elm !=='undefined') elm.click();
            }
        }
    }

</script>
<style scoped>

    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }
    .editEventActions .deleteBtn{
        width:218px;
        height:54px;
        background: #fff;
        border:1px solid #d4d4d4;
        border-radius:27px;
        margin-left:30px;

    }
    .editEventActions .deleteBtn span{
        color:#293b5a;
        font-weight:700;
        font-size:1rem;
        display:inline-block;
        vertical-align:middle;
    }
    .editEventActions .deleteBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:19px;
        height:23px;
        fill:#849dc8;
        margin-left:10px;
    }
    .innerBox{
        padding:30px;
    }
    .tabsWrap li a span{
        font-weight:bold;
        color:#a3a3a3;
        font-size:1.294rem;
        display:inline-block;
        vertical-align:bottom;
    }
    .tabsWrap li a svg{
        display:inline-block;
        vertical-align:bottom;
        fill:#a3a3a3;
        margin-left:10px;
    }
    .tabsWrap li a svg.i_event_tab{
        width:36px;
        height:36px;
    }
    .tabsWrap li a svg.i_offer_tab{
        width:30px;
        height:36px;
    }
    .tabsWrap li a svg.i_meeting_tab{
        width:31px;
        height:36px;
    }
    .tabsWrap li.active a span{
        color:#7d97c5;
    }
    .tabsWrap li.active a svg{
        fill:#293b5a;
    }
    .nav-tabs>li>a{
        border-radius: 0;
        padding: 15px 40px;
    }
    .nav-tabs>li.active>a, .nav-tabs>li.active>a:hover, .nav-tabs>li.active>a:focus{
        border-color:transparent;
        border-bottom-color:#293b5a;
        background: transparent;
    }
    .nav>li>a:hover, .nav>li>a:focus{
        background-color:transparent;
        border-color:transparent;
    }
    .formWrap .inputWrap{
        margin-top:20px;
    }
    @media only screen and (min-width:580px) and (max-width:768px){
        .editEventActions .deleteBtn{width: 185px;height: 45px;margin-left: 15px;}
        .h1Wrap{width: 210px;}
    }
</style>
